import { TimelineMax } from 'gsap'

/**
 * INIT
 * ----
 * This function initialize every element of the main header
 **/
export function init() {
  setupYearFilter()
}

function setupYearFilter() {
  const tlFilterOpen = new TimelineMax({ 
    paused: true,
    onComplete: _ => {
    } 
  })
  const tlFilterClose = new TimelineMax({
    paused: true,
    onComplete: _ => {
      TweenLite.set([
        '.search--wrapper'
      ], {clearProps: 'all'})
    }
  })

  // open
  tlFilterOpen
    .add('start')
    .set('.page-header--years-list', { className: '+=opened' }, 'start+=0.2')
    .set('.open-volume-taxonomies span', { className: '+=opened' }, 'start+=0.2')
    .to('.page-header--years-list', 0.6, {opacity: 1, y: 0, 'pointer-events': 'auto', ease: Power4.easeInOut}, 'start')

  // open
  tlFilterClose
    .add('start')
    .set('.page-header--years-list', { className: '-=opened' }, 'start+=0.2')
    .set('.open-volume-taxonomies span', { className: '-=opened' }, 'start+=0.2')
    .to('.page-header--years-list', 0.6, {opacity: 0, y: -20, 'pointer-events': 'none', ease: Power4.easeInOut}, 'start')

  
  $('.page-header--year-selection').on('click', function(e) {
    e.preventDefault()
  })

  $('.page-header--year-selection--change').on('click', function(e) {
    e.preventDefault()    
    let $_this = $(this)

    if($_this.parent().hasClass('open')) {
      $_this.parent().toggleClass('open')
    } else {
      $('.page-header--year-selection--change').parent().removeClass('open')
      $_this.parent().addClass('open')
    }
  })

  $('.page-header--years-list > span').on('click', function() {
    let $_this = $(this)
    let year = $(this).data('year')
    let type = $(this).data('type')

    $('.page-header--title').addClass('show-submit')
    $('.page-header--year-selection--change').parent().removeClass('open')

    if(type === 'from') {
      $('.page-header--year-selection-from').find('.value').text(year)
    } else {
      $('.page-header--year-selection-to').find('.value').text(year)
    }
  })

  $('.page-header--years-submit').on('click', function(e) {
    e.preventDefault()
    let $_this = $(this)
    let fromYear = $('.page-header--year-selection-from .value').text()
    let toYear = $('.page-header--year-selection-to .value').text()

    window.location = '?from=' + fromYear + '&to=' + toYear
  })  


  // document.addEventListener('keyup', (e) => { 
  //   if(e.keyCode === 27) {
  //     if($('.page-header--years-list').hasClass('opened')) {
  //       tlFilterClose.restart()
  //     }
  //   }
  // })
}


// WEBPACK FOOTER //
// ./scripts/components/IssueArchive.js